import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import BlueBookTeacherPlayer from 'chameleon-src/components/blueBook/TeacherPlayer';
import withLearnosityConfig from 'chameleon/packages/blue-book-player/hocs/withLearnosityConfig';
import { withAssessmentPreview } from 'chameleon/ui-stack/hocs/player';
import { LoadingSpinner } from 'chameleon/legacy/packages/ft-cb';

const AssessmentPreviewPlayerBB = (props) => {
  const {
    itemId,
    params,
    onQuestionChanged,
    onItemLoad = () => {},
    questions,
    getCurrentQuestionIndex,
    onOrderChange,
    isReordering,
    userData,
    loading,
    assessment,
    refetch,
    learnosityServerData,
    allowCalculatorForItems,
    isModal = false,
  } = props;
  if (!itemId) return;

  useEffect(() => {
    if (loading === false && assessment) {
      onItemLoad(assessment, refetch);
    }
  }, [loading, assessment]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <BlueBookTeacherPlayer
      isPreviewPlayer
      userData={userData}
      params={params}
      subject={params.subject}
      itemId={itemId}
      onOrderChange={onOrderChange}
      isReordering={isReordering}
      questions={questions}
      assessment={assessment}
      learnosityServerData={learnosityServerData}
      allowCalculatorForItems={allowCalculatorForItems}
      isModal={isModal}
      getCurrentQuestionIndex={getCurrentQuestionIndex}
      onQuestionChanged={onQuestionChanged}
    />
  );
};

const mapStateToProps = (state) => {
  const { featureFlag, impersonating, userData } = state;
  const apTeacherImpersonatesStudent =
    featureFlag.ap_teacher_impersonates_student;
  const isReadOnly = impersonating && impersonating.isReadOnly;
  return {
    userData,
    isImpersonating:
      Boolean(isReadOnly && apTeacherImpersonatesStudent) ||
      window.localStorage.getItem('isReadOnly') === 'true',
    areFeatureFlagsLoaded: featureFlag.areFeatureFlagsLoaded,
  };
};

export default compose(
  connect(mapStateToProps),
  withRouter,
  withLearnosityConfig({ isBlueBook: true }),
  withAssessmentPreview,
)(AssessmentPreviewPlayerBB);
